import { useState } from "react";

import TranslateIcon from "@mui/icons-material/Translate";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useUIStore } from "@/store/uiStore";

const LOCALES: Array<{ code: string; label: string }> = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
];

export function LocaleSwitcher() {
  const { t, i18n } = useTranslation();
  const { setLocale } = useUIStore();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Tooltip title={t("common.language")}>
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          aria-label={t("common.language")}
          color="inherit"
        >
          <TranslateIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {LOCALES.map((l) => (
          <MenuItem
            key={l.code}
            selected={i18n.language?.startsWith(l.code)}
            onClick={() => {
              void i18n.changeLanguage(l.code);
              setLocale(l.code);
              setAnchorEl(null);
            }}
          >
            {l.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
